// services/deptOwnerService.js — Read/write the dept-owner mapping JSON
// File stored at the root of the site's default Documents library:
//   /sites/{siteId}/drive/root:/LekOil_DeptOwnerMap.json
//
// JSON format:
// {
//   "WELL ENGINEERING": {
//     "name": "John Doe",
//     "email": "john.doe@lekoil.com",
//     "jobTitle": "Head, Well Engineering",
//     "department": "Well Engineering"
//   },
//   ...
// }

import { getSiteId } from "./sharepointService";

const MAP_FILENAME = "LekOil_DeptOwnerMap.json";
const graphBase = "https://graph.microsoft.com/v1.0";

export async function fetchDeptOwnerMap(token) {
  const siteId = await getSiteId(token);
  const res = await fetch(
    `${graphBase}/sites/${siteId}/drive/root:/${MAP_FILENAME}:/content`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  if (res.status === 404) return null; // file doesn't exist yet
  if (!res.ok) throw new Error(`Failed to load dept-owner map (HTTP ${res.status})`);
  return res.json();
}

export async function saveDeptOwnerMap(token, map) {
  const siteId = await getSiteId(token);
  const res = await fetch(
    `${graphBase}/sites/${siteId}/drive/root:/${MAP_FILENAME}:/content`,
    {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(map, null, 2),
    },
  );
  if (!res.ok) throw new Error(`Failed to save dept-owner map (HTTP ${res.status})`);
  return res.json();
}
